import pattern from 'patterns/vimeo';
import { WCCContentVimeoBlock } from '../blocks/vimeo/vimeo';
import WCCContentPatternRule from './pattern';

export default class WCCContentVimeoRule extends WCCContentPatternRule {
    protected pattern = pattern;

    protected process([content, id]: RegExpExecArray) {
        return new WCCContentVimeoBlock({ content, id });
    }
}